import { render, staticRenderFns } from "./integralTask.vue?vue&type=template&id=1c473a73&scoped=true"
import script from "./integralTask.vue?vue&type=script&lang=js"
export * from "./integralTask.vue?vue&type=script&lang=js"
import style0 from "./integralTask.vue?vue&type=style&index=0&id=1c473a73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c473a73",
  null
  
)

export default component.exports